import Loading from "../components/Shared/Loading"

export default {
    components: {
        Loading,
    },
    props: {
        
    },
    data() {
        return {
            
        }
    },
    computed: {
        root() {
            return process.env.VUE_APP_API_URL || `https://coc-api.xuyenmandem.com`
        },
        tag() {
            return this.$route.params.tag ? this.$route.params.tag.toUpperCase() : ''
        },
    },
    methods: {
        getRandomMeals(size) {
            const startIndex = Math.floor(Math.random() * (this.meals.length - size + 1))
            const endIndex = startIndex + size
            return this.meals.slice(startIndex, endIndex)
        },
    },
}